import { createSlice } from '@reduxjs/toolkit';
import { State } from '../state.types';
import {
  LayoutState,
  DimensionsKey,
  LayoutDimensions,
  SetDimensionsAction,
  RemoveDimensionsAction,
} from './layout.types';

const initialState: LayoutState = {
  dimensions: {},
};

const layout = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setDimensions(state, { payload }: SetDimensionsAction) {
      const [key, dimensions] = payload;

      state.dimensions[key] = dimensions;
    },
    removeDimensions(state, { payload: key }: RemoveDimensionsAction) {
      delete state.dimensions[key];
    },
  },
});

export const { setDimensions, removeDimensions } = layout.actions;

export const selectDimensions =
  (key: DimensionsKey) =>
  (state: State): LayoutDimensions | undefined =>
    state.layout.dimensions[key];

export default layout.reducer;
